module.exports = __webpack_public_path__ + "static/img/usb.8cc091a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/usb.png
// module id = eCUa
// module chunks = 0